import { Controller, useFieldArray, useForm, useWatch } from "react-hook-form";
import TextArea from "../../../components/form-controls/TextArea"
import Select from 'react-select'
import Input from "../../../components/form-controls/Input";
import { useEffect, useState } from "react";
import { AlertService } from "../../../services/Alert";
import { MetaService } from "../../../services/MetaService";
import { useCurrentAccount } from "../../../hooks/useCurrentAccount";
import { useTranslation } from "react-i18next";
import QuickReplyBtn from "./QuickReplyBtn";
import UrlBtn from "./UrlBtn";

function parcialRCS({ isValidForm, onChange }) {

    const { t } = useTranslation();

    const { account } = useCurrentAccount();

    const defaultHeaderValues = {
        type: 'HEADER',
        format: {
            value: 'text',
            label: 'Título'
        },
        text: '',
        content: {
            value: '',
            label: ''
        },
        file: '',
        example: {
            header_handle: ''
        },
        url: ''
    }
    const defaultBodyValues = {
        type: 'BODY',
        text: '',
        example: {
            body_text: []
        }
    }
    const defaultButtonValues = {
        type: '',
        text: '',
        url: '',
        style: '',
        example: '',
    }
    const defaultButtonsValues = {
        type: 'BUTTONS',
        buttons: [],
    }
    const defaultValues = {
        header: defaultHeaderValues,
        body: defaultBodyValues,
        buttons: defaultButtonsValues,
        name: ''
    }

    const [canBtnBlacklist, setCanBtnBlacklist] = useState(false);


    const { control, register, watch, setValue, formState: { errors, isValid } } = useForm({
        mode: 'onChange',
        defaultValues
    });

    const form = useWatch({ control })

    const bodyVars = useFieldArray({
        control,
        name: "body.example.body_text",
    });

    const buttonActionsArray = useFieldArray({
        control,
        name: "buttons.buttons",
    });

    const header = watch('header');
    const body = watch('body.text');
    const buttons = watch('buttons');

    const uploadFile = async ({ target: { files } }) => {
        const bytesToMegabytes = (bytes) => {
            const megabytes = bytes / (1024 * 1024);
            return megabytes.toFixed(2);
        };
    
        const file = files[0];
        const sizeMB = +bytesToMegabytes(file.size);
        const type = header.content.value;
    
        if (sizeMB > 5) {
            AlertService.toastError('Sólo se permiten archivos de máximo 5MB');
            setValue('header.file', '');
            return;
        }
    
        if (type === 'image' && (file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file.type !== 'image/png')) {
            AlertService.toastError('Sólo se permiten imágenes en formato png o jpg');
            setValue('header.file', '');
            return;
        }
        if (type === 'video' && file.type !== 'video/mp4') {
            AlertService.toastError('Sólo se permiten videos en formato mp4');
            setValue('header.file', '');
            return;
        }
    
        const handleFileUpload = async (fileToUpload) => {
            const data = new FormData();
            data.append('file', fileToUpload);
            data.append('account_id', account.id);
    
            const promise = async () => {
                const response = await MetaService.uploadMedia(data);
                setValue('header.example.header_handle', response.data.metaID);
                setValue('header.url', response.data.url);
            };
    
            AlertService.toastLoading(
                promise(),
                'Guardando archivo...',
                'El archivo se guardó correctamente',
                'Ocurrió un error al guardar el archivo, intenta nuevamente'
            );
        };
    
        if (type === 'image') {
            const img = new Image();
            const objectUrl = URL.createObjectURL(file);
            img.src = objectUrl;
    
            img.onload = async () => {
                const width = img.naturalWidth;
                const height = img.naturalHeight;
                URL.revokeObjectURL(objectUrl);
    
                if (width !== 1440 || height !== 720) {
                    const resizedFile = await resizeImage(file, 1440, 720);
                    await AlertService.toastSuccess('Imagen redimensionada correctamente.');
                    await handleFileUpload(resizedFile);
                } else {
                    await handleFileUpload(file);
                }
            };
        } else {
            await handleFileUpload(file);
        }
    };
    const resizeImage = (file: File, targetWidth: number, targetHeight: number): Promise<Blob> => {
        return new Promise((resolve, reject) => {
            const img = document.createElement('img');
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            const objectUrl = URL.createObjectURL(file);
    
            img.src = objectUrl;
            img.onload = () => {
                URL.revokeObjectURL(objectUrl);
                canvas.width = targetWidth;
                canvas.height = targetHeight;
                ctx.drawImage(img, 0, 0, targetWidth, targetHeight);
                canvas.toBlob((blob) => {
                    if (blob) {
                        resolve(blob);
                    } else {
                        reject(new Error('Error resizing image'));
                    }
                }, file.type);
            };
            img.onerror = reject;
        });
    };
    
    const addBtn = (type: string) => {
        buttonActionsArray.append({
            ...defaultButtonValues,
            type,
            is_btn_blacklist: false
        })
    }


    const handleName = ({ target: { value } }) => {

        const newValue = value
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/[^\w\s]/gi, "")
            .replace(/\s+/g, "_")
            .toLowerCase();


        setValue('name', newValue)
    }



    useEffect(() => {
        const match = body.match(/{{\d+}}/g);
        if (!match) return bodyVars.replace([]);

        let tokens = match.map(t => t.replace(/{{|}}/gi, ""))
        tokens = tokens.filter((x, i, a) => a.indexOf(x) == i)

        bodyVars.replace(tokens.map(t => ({ key: t, value: '' })))
    }, [body])

    useEffect(() => {
        isValidForm(isValid)
    }, [isValid])

    useEffect(() => {
        onChange(form)

        const exists = form.buttons.buttons.find((b) => b.type === 'QUICK_REPLY_DISABLE_MKT');
        setCanBtnBlacklist(exists ? true : false)

    }, [form])

    useEffect(() => {
        setValue('header.file', '')
    }, [header.content.value])


    return (
        <>
            <div className="row ">
                <div className="col-8">
                    <div className="card ">
                        <div className="card-header card-header-content-between">
                            <h4 className="card-title">Nombre <span className="text-danger">*</span></h4>
                        </div>
                        <div className="card-body">
                            <span className="d-block fs-5 mb-3">Asigna un nombre a tu plantilla RCS</span>
                            <div className="mb-3">
                                <Input
                                    errors={errors.name} {...register('name', { required: true, maxLength: { value: 512, message: '512' }, onChange: handleName })}
                                    currentLength={watch('name').length}
                                    maxLength={512}
                                />
                            </div>
                        </div>
                    </div>
                    <hr />

                    <div className="card ">
                        <div className="card-header card-header-content-between">
                            <h4 className="card-title">Encabezado <span className="text-danger">*</span></h4>
                        </div>
                        <div className="card-body">
                            <span className="d-block fs-5 mb-3">  {t("platform.channels.templates.header-text")}</span>
                            <div className="row">
                                <div className=" col-6">
                                    <Controller
                                        control={control}
                                        name='header.format'
                                        rules={{ required: true }}
                                        render={
                                            ({
                                                field: { onChange, value } }) => (
                                                <Select
                                                    options={[
                                                        { value: 'text', label: 'Título' },
                                                        { value: 'media', label: t("platform.channels.templates.media") },
                                                    ]}
                                                    className={'form-select-custom '}
                                                    classNamePrefix='form-select-custom'
                                                    placeholder='Tipo de encabezado'
                                                    onChange={(data: any) => onChange(data)}
                                                    value={value as any}
                                                />
                                            )
                                        }
                                    />
                                </div>
                                {
                                    header.format.value === 'text' && (
                                        <div className=" col-6">
                                            <Input
                                                {...register('header.text', { required: true, maxLength: { value: 60, message: '60' } })}
                                                errors={errors.header?.text}
                                                currentLength={header.text.length}
                                                maxLength={60}
                                                placeholder="Escribe el título"
                                            />
                                        </div>
                                    )
                                }
                                {
                                    header.format.value === 'media' && (
                                        <div className=" col-6">
                                            <Controller
                                                control={control}
                                                name='header.content.value'
                                                rules={{ required: true }}
                                                render={
                                                    ({
                                                        field: { onChange, value } }) => {
                                                        const options = [
                                                            { value: 'image', label: t("platform.channels.templates.image") },
                                                            { value: 'video', label: t("platform.channels.templates.video") }
                                                        ]

                                                        return (
                                                            <Select
                                                                options={options}
                                                                className={'form-select-custom '}
                                                                classNamePrefix='form-select-custom'
                                                                placeholder="Elige una imagen o video"
                                                                onChange={(data: any) => onChange(data.value)}
                                                                value={options.find(o => o.value === value)}
                                                            />
                                                        )
                                                    }
                                                }
                                            />
                                        </div>
                                    )
                                }

                            </div>
                            {
                                header.format.value === 'media' && header.content.value && (
                                    <div className="row mt-3">
                                        <div className="col">
                                            <div className="alert alert-soft-secondary" role="alert">
                                                <h5>{t("platform.channels.templates.content-label")}</h5>
                                                <p>{t("platform.channels.templates.content-p")}</p>
                                                <div>
                                                    <Input
                                                        label={header.content.value === 'image' ? t("platform.channels.templates.image") : header.content.value === 'video' ? t("platform.channels.templates.video") : t("platform.channels.templates.pdf")}
                                                        type='file'
                                                        errors={errors.header?.file}
                                                        {...register('header.file', { required: true, onChange: uploadFile })}
                                                        sizeClass='form-control-sm'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                    <hr />

                    <div className="card">
                        <div className="card-header card-header-content-between">
                            <h4 className="card-title">Mensaje <span className="text-danger">*</span></h4>
                        </div>

                        <div className="card-body">
                            <span className="d-block fs-5 mb-3">{t("platform.channels.templates.text-p")}</span>
                            <div className="mb-3">
                                <TextArea
                                    errors={errors.body?.text}
                                    value={watch('body.text').length}
                                    counter={1024}
                                    {...register('body.text', { required: true, maxLength: { value: 1024, message: '1024' } })} />

                            </div>

                            {
                                bodyVars.fields.length > 0 && (
                                    <div className="mb-3">
                                        <div className="alert alert-soft-secondary" role="alert">
                                            <h5>Ejemplos de contenido del cuerpo</h5>
                                            <p>Agrega un ejemplo en cada variable del texto del cuerpo para que META pueda revisar tu plantilla de mensaje. No uses información verdadera de clientes. La API de la nube, alojada por Meta, revisa las plantillas y los parámetros de las variables para garantizar la seguridad e integridad de nuestros servicios.</p>

                                            <h6>Texto</h6>
                                            {
                                                bodyVars.fields.map((row, index) => (
                                                    <div className="d-flex align-items-center mb-2" key={row.id}>
                                                        <label className="form-label mx-3" >{`{{${watch(`body.example.body_text.${index}.key`)}}}`}</label>
                                                        <div className="flex-grow-1">
                                                            <Input
                                                                errors={errors.body?.example?.body_text?.[index]} {...register(`body.example.body_text.${index}.value`, { required: true })}
                                                                sizeClass='form-control-sm'
                                                            />
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                )
                            }


                        </div>
                    </div>
                    <hr />
                    <div className="card">
                        <div className="card-header card-header-content-between">
                            <h4 className="card-title">Botones <span className="badge bg-soft-secondary text-secondary">{t("platform.channels.templates.optional-label")} (Máx.. 4 botones)</span></h4>
                            <div className="row">
                                <div className=" col-12">
                                    <div className={`dropdown ${buttonActionsArray.fields.length >= 4 ? 'd-none' : ''}`}>
                                        <button className="btn btn-primary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                            <i className="bi-plus-lg"></i>{t("platform.channels.templates.add-btn")}
                                        </button>
                                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <button type="button" className="dropdown-item" onClick={() => addBtn('URL')}>Ir al sitio web</button>
                                            <button type="button" className="dropdown-item" onClick={() => addBtn('QUICK_REPLY')}>{t("platform.channels.templates.quick-response")}</button>
                                            <button type="button" className="dropdown-item" onClick={() => addBtn('QUICK_REPLY_DISABLE_MKT')} disabled={canBtnBlacklist}>Desactivar envio de plantillas</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <span className="d-block fs-5 mb-3">Crea botones que les permitan a los clientes responder a tu mensaje o realizar cualquier acción.</span>

                            <hr />
                            {
                                (buttonActionsArray.fields.length > 0) && (
                                    <div className="row  mb-3">
                                        <div className="col">
                                            {
                                                buttonActionsArray.fields.map((row, index) => (

                                                    <div key={row.id}>
                                                        {
                                                            row.type === 'QUICK_REPLY' && (
                                                                <QuickReplyBtn
                                                                    errors={errors.buttons?.buttons?.[index]}
                                                                    register={register}
                                                                    index={index}
                                                                    watch={watch}
                                                                    onDelete={() => buttonActionsArray.remove(index)}
                                                                    type={row.type}
                                                                />
                                                            )
                                                        }
                                                        {
                                                            row.type === 'QUICK_REPLY_DISABLE_MKT' && (
                                                                <QuickReplyBtn
                                                                    errors={errors.buttons?.buttons?.[index]}
                                                                    register={register}
                                                                    index={index}
                                                                    watch={watch}
                                                                    onDelete={() => buttonActionsArray.remove(index)}
                                                                    type={row.type}
                                                                />
                                                            )
                                                        }
                                                        {
                                                            row.type === 'URL' && (
                                                                <UrlBtn
                                                                    errors={errors.buttons?.buttons?.[index]}
                                                                    register={register}
                                                                    index={index}
                                                                    watch={watch}
                                                                    onDelete={() => buttonActionsArray.remove(index)}
                                                                />
                                                            )
                                                        }
                                                    </div>

                                                ))
                                            }
                                        </div>
                                    </div>
                                )
                            }

                        </div>
                    </div>
                </div>
                <div className="col-4">
                    <div className="sticky">
                        <div className="wrap-android ms-4">
                            <div className="preview-container-RCS">
                                <div className="preview-template-RCS">
                                    {header.format.value === 'text' && (
                                        <div className="preview-template-header fw-bold text-dark">{header.text}</div>
                                    )}
                                    {header.format.value === 'media' && header.content.value === 'image' && (
                                        <div className="preview-template-header">
                                            {!header.url && <div className="preview-template-img-container"></div>}
                                            {header.url && <div
                                                className="preview-template-img-container-url"
                                                style={{ backgroundImage: `url(${header.url})` }}
                                            ></div>}

                                        </div>
                                    )}
                                    {header.format.value === 'media' && header.content.value === 'video' && (
                                        <div className="preview-template-header">
                                            <div className="preview-template-video-container">
                                            </div>
                                        </div>
                                    )}
                                    <div className="text-dark mb-3" dangerouslySetInnerHTML={{ __html: body.replace(/\n/g, '<br/>') }}></div>
                                    {buttons.buttons.map((btn, index) => (
                                        <div key={index} className={`preview-template-btn text-btn-rcs d-flex align-items-center justify-content-center${index !== 0 ? ' border-top mt-2 pt-2 divider-btn-rcs' : ''}`}>
                                            {btn.type === 'URL' && (
                                                <>
                                                    <i className="bi bi-globe-americas"></i> {btn.text}
                                                </>
                                            )}
                                            {btn.type === 'QUICK_REPLY' && (
                                                <>
                                                    <i className="bi bi-send"></i> {btn.text}
                                                </>
                                            )}
                                            {btn.type === 'QUICK_REPLY_DISABLE_MKT' && (
                                                <>
                                                    <i className="bi bi-dash-circle"></i> {btn.text}
                                                </>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}
export default parcialRCS